import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { CLASS_ANNOUNCEMENT_REPOSITORY } from '../core/domain/repositories/class-announcement.repository';
import { CLASS_ANNOUNCEMENT_API, ClassAnnouncementApi } from './data-sources/apis/class-announcement.api';
import { ClassAnnouncementRepository } from './repositories/class-announcement-web.repository';
import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { CLASS_REPOSITORY } from '../core/domain/repositories/class.repository';
import { CLASS_API, ClassApi } from './data-sources/apis/class.api';
import { ClassRepository } from './repositories/class-web.repository';
export var ClassRepositoryWebModule = /*#__PURE__*/function () {
  function ClassRepositoryWebModule() {
    _classCallCheck(this, ClassRepositoryWebModule);
  }

  _createClass(ClassRepositoryWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: ClassRepositoryWebModule,
        providers: [{
          provide: CLASS_ANNOUNCEMENT_API,
          useFactory: function useFactory() {
            return new ClassAnnouncementApi(new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
              Authorization: "Bearer ".concat(config.accessToken)
            }).toInstance());
          }
        }, {
          provide: CLASS_ANNOUNCEMENT_REPOSITORY,
          useFactory: function useFactory(api) {
            return new ClassAnnouncementRepository(api);
          },
          inject: [CLASS_ANNOUNCEMENT_API]
        }, {
          provide: CLASS_API,
          useFactory: function useFactory() {
            return new ClassApi(new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
              Authorization: "Bearer ".concat(config.accessToken)
            }).toInstance());
          }
        }, {
          provide: CLASS_REPOSITORY,
          useFactory: function useFactory(api) {
            return new ClassRepository(api);
          },
          inject: [CLASS_API]
        }],
        exports: [CLASS_REPOSITORY, CLASS_ANNOUNCEMENT_REPOSITORY]
      };
    }
  }]);

  return ClassRepositoryWebModule;
}();